/* istanbul ignore file */
import { Page404 } from 'framework/statusPages';
import useAuthenticationService from 'infrastructure/security/authentication/authenticationService';
import { Navigate, Route, useLocation } from 'react-router-dom';
import { EmployeesRouter } from './employee';
import { EmployeePortalRouter } from './employee/portal';
import EmployeeScoreRouter from './employee/employeeScore/EmployeeScoreRouter';
import EmployeesDashboardRouter from './employee/dashboard/EmployeesDashboardRouter';
import QualificationStructureRouter from './employee/qualificationStructure/QualificationStructureRouter';
import PerformanceMeasurementRouter from './employee/performanceMeasurement/PerformanceMeasurementRouter';
import { ContractsRouter } from './contracts';
import { PerformanceReportRouter } from './performanceReport';
import { NewCompetencyRouter } from './career/qualification/newCompetency';
import { CompetencyRouter } from './career/qualification/competency';
import PositionSlotsRouter from './positionSlots/PositionSlotsRouter';
import WorkforceAnalyticsRouter from './workforceAnalytics/WorkforceAnalyticsRouter';
import PositionProfilesRouter from './positionProfiles/PositionProfilesRouter';
import { Features, featureToggles } from 'infrastructure/featureToggle';
import { filterTruthy } from 'framework/utils';
import { EMPLOYEES_PATH, WORKERS_PATH } from 'domain/shared/employee';
import { LEGACY_EMPLOYEES_DASHBOARD_PATH, WORKERS_DASHBOARD_PATH } from './employee/dashboard/constants';
import LeaveRouter from './leave/LeaveRouter';
import SyberryTodayRouter from './syberryToday/SyberryTodayRouter';

const LegacyEmployeesRedirect = () => {
  const { pathname, search, hash } = useLocation();
  const targetPath = pathname.replace(EMPLOYEES_PATH, WORKERS_PATH);

  return <Navigate to={`${targetPath}${search}${hash}`} replace />;
};

const LegacyEmployeesDashboardRedirect = () => {
  const { pathname, search, hash } = useLocation();
  const targetPath = pathname.replace(LEGACY_EMPLOYEES_DASHBOARD_PATH, WORKERS_DASHBOARD_PATH);

  return <Navigate to={`${targetPath}${search}${hash}`} replace />;
};

const positionSlotsEnabled = Boolean(featureToggles[Features.POSITION_SLOTS]);
const positionProfilesEnabled = Boolean(featureToggles[Features.POSITION_PROFILES]);
const workforceAnalyticsEnabled = positionSlotsEnabled && Boolean(featureToggles[Features.WORKFORCE_ANALYTICS]);
const syberryTodayEnabled = Boolean(featureToggles[Features.SYBERRY_TODAY]);

const PeopleRouter = () => {
  const { isAuthenticated } = useAuthenticationService();

  return [
    <Route path={`${EMPLOYEES_PATH}/*`} element={<LegacyEmployeesRedirect />} />,
    <Route path={EmployeesRouter.getRouterPath()} element={<EmployeesRouter />} />,
    <Route path={EmployeePortalRouter.getRouterPath()} element={<EmployeePortalRouter />} />,
    <Route path={EmployeeScoreRouter.getRouterPath()} element={<EmployeeScoreRouter />} />,
    <Route path={`${LEGACY_EMPLOYEES_DASHBOARD_PATH}/*`} element={<LegacyEmployeesDashboardRedirect />} />,
    <Route path={EmployeesDashboardRouter.getRouterPath()} element={<EmployeesDashboardRouter />} />,
    <Route path={QualificationStructureRouter.getRouterPath()} element={<QualificationStructureRouter />} />,
    <Route path={PerformanceMeasurementRouter.getRouterPath()} element={<PerformanceMeasurementRouter />} />,
    <Route path={ContractsRouter.getRouterPath()} element={<ContractsRouter />} />,
    <Route path={PerformanceReportRouter.getRouterPath()} element={<PerformanceReportRouter />} />,
    positionProfilesEnabled && (
      <Route path={PositionProfilesRouter.getRouterPath()} element={<PositionProfilesRouter />} />
    ),
    <Route path={NewCompetencyRouter.getRouterPath()} element={<NewCompetencyRouter />} />,
    <Route path={CompetencyRouter.getRouterPath()} element={<CompetencyRouter />} />,
    <Route path={LeaveRouter.getRouterPath()} element={<LeaveRouter />} />,
    positionSlotsEnabled && <Route path={PositionSlotsRouter.getRouterPath()} element={<PositionSlotsRouter />} />,
    workforceAnalyticsEnabled && (
      <Route path={WorkforceAnalyticsRouter.getRouterPath()} element={<WorkforceAnalyticsRouter />} />
    ),
    syberryTodayEnabled && <Route path={SyberryTodayRouter.getRouterPath()} element={<SyberryTodayRouter />} />,

    <Route path="*" element={<Page404 isAuthenticated={isAuthenticated} />} />,
  ].filter(filterTruthy);
};

export default PeopleRouter;
